import React from 'react'
import Header from '../main/Header'
import Footer from '../main/Footer'
import { Link } from 'react-router-dom'

export default function Contact() {
    return (
        <>
            <Header />
            <section className="page-title">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 col-md-12">
                            <div className="breadcrumbs-wrap">
                                <h1 className="breadcrumb-title">Get in Touch</h1>
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item">
                                            <Link to={"/"}>Home</Link>
                                        </li>
                                        <li className="breadcrumb-item active" aria-current="page">
                                            Contact
                                        </li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='bg-light my-4'>

                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2740.8267384952524!2d75.72045517410493!3d27.166638149134624!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x396dabfa74af5bf9%3A0x6246830cdd05eb10!2sNational%20Computer%20Classes!5e1!3m2!1sen!2sin!4v1737366945226!5m2!1sen!2sin"
                    width={'100%'}
                    height={450}
                    style={{ border: 0 }}
                    allowFullScreen="true"
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                />


            </section>
            <section className="bg-light">
                <div className="container">
                    {/* row Start */}
                    <div className="row">
                        <div className="col-lg-8 col-md-7">
                            <div className="prc_wrap">
                                <div className="prc_wrap_header">
                                    <h4 className="property_block_title">Fillup The Form</h4>
                                </div>
                                <div className="prc_wrap-body">
                                    <div className="row">
                                        <div className="col-lg-6 col-md-12">
                                            <div className="form-group">
                                                <label>Name</label>
                                                <input type="text" className="form-control simple" />
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-12">
                                            <div className="form-group">
                                                <label>Email</label>
                                                <input type="email" className="form-control simple" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label>Subject</label>
                                        <input type="text" className="form-control simple" />
                                    </div>
                                    <div className="form-group">
                                        <label>Message</label>
                                        <textarea className="form-control simple" defaultValue={""} />
                                    </div>
                                    <div className="form-group">
                                        <button type="submit" className="btn btn-theme" >
                                            Submit Request
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-5">
                            <div className="prc_wrap">
                                <div className="prc_wrap_header">
                                    <h4 className="property_block_title">Reach Us</h4>
                                </div>
                                <div className="prc_wrap-body">
                                    <div className="contact-info">
                                        <h2>Get In Touch</h2>
                                        <p>
                                            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do{" "}
                                        </p>
                                        <div className="cn-info-detail">
                                            <div className="cn-info-icon">
                                                <i className="ti-home" />
                                            </div>
                                            <div className="cn-info-content">
                                                <h4 className="cn-info-title">Reach Us</h4>
                                                2nd Floor, Star Complex, Rajasthan,
                                                <br />
                                                Near by Canara Bank, Chomu, Jaipur,
                                                <br />
                                                India 303702
                                            </div>
                                        </div>
                                        <div className="cn-info-detail">
                                            <div className="cn-info-icon">
                                                <i className="ti-email" />
                                            </div>
                                            <div className="cn-info-content">
                                                <h4 className="cn-info-title">Drop A Mail</h4>
                                                nationalcomputer11024@gmail.com

                                            </div>
                                        </div>
                                        <div className="cn-info-detail">
                                            <div className="cn-info-icon">
                                                <i className="ti-mobile" />
                                            </div>
                                            <div className="cn-info-content">
                                                <h4 className="cn-info-title">Call Us</h4>
                                                {/* (41) 123 521 458 */}
                                                {/* <br /> */}
                                                +91-9785012301
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* /row */}
                </div>
            </section>


            <Footer />
        </>
    )
}
